import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";

import GridOnIcon from "@mui/icons-material/GridOn";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";
import queryString from "query-string";
import { useDealActions, useSelectedBookmarkSelector, useUserActions } from "store";
import { IBookmark } from "store/types";

import { GroupItem } from "./GroupItem";

export const DealBookmark: React.FC<IBookmark> = ({
  params,
  name,
  id,
  is_default,
  is_private,
  account_default,
  user,
  type
}) => {
  const { push } = useHistory();

  const { updateQueries } = useDealActions();
  const selectedBookmark = useSelectedBookmarkSelector();
  const { setSelectedBookmark } = useUserActions();

  const { deals: dealsFromAPI } = queryString.parseUrl(params).query;
  const bookmarkPath = params.split("?")[0];

  const handleClick = useCallback(() => {
    if (dealsFromAPI && !Array.isArray(dealsFromAPI)) {
      setSelectedBookmark(id);
      updateQueries(JSON.parse(dealsFromAPI), true);
      setTimeout(() => push(bookmarkPath), 0);
    }
  }, [dealsFromAPI, bookmarkPath]);

  return (
    <GroupItem
      icon={
        <MaterialTooltip isShow placement="top" title={type === "deal" ? "Deal" : "Dashboard Investor View"}>
          {type === "deal" ? (
            <GridOnIcon sx={{ fontSize: "18px" }} />
          ) : (
            <PeopleAltOutlinedIcon sx={{ fontSize: "18px" }} />
          )}
        </MaterialTooltip>
      }
      id={id}
      title={name}
      ownerData={user}
      isActive={selectedBookmark === id}
      onClick={handleClick}
      allowSetDefault
      isDefault={is_default}
      isPrivate={is_private}
      isAccountDefault={account_default}
      bookmarkType={type}
    />
  );
};
